import { FormField, FormResponseValue } from "@tellescope/types-models";
import { getNextField } from "./get-next-field";
import { NextFieldLogicOptions } from "./types";

/**
 * Converts a tree structure into an ordered list of fields based on responses
 * Starts from the root and iteratively builds the list using getNextField
 * Prevents infinite loops by checking for duplicate fields
 */
export const buildOrderedFieldList = (
  fields: FormField[],
  responses: FormResponseValue[],
  options?: NextFieldLogicOptions
): FormField[] => {
  const list: FormField[] = [];

  const root = fields.find((f) => f.previousFields.find((p) => p.type === "root"));
  if (!root) return [];

  list.push(root);
  while (true) {
    const lastField = list[list.length - 1];
    if (!lastField) break;

    const currentValue = responses.find((r) => r.fieldId === lastField.id);

    const nextField = getNextField(
      {
        value: lastField,
        children: fields
          .filter((f) => f.previousFields.find((p) => p.type !== "root" && p.info.fieldId === lastField.id))
          .map((value) => ({
            value,
            children: [],
          })),
      },
      currentValue,
      responses,
      {
        ...options,
        activeResponses: responses.filter(
          (r) => r.fieldId === currentValue?.fieldId || list.find((l) => l.id === r.fieldId)
        ),
      }
    );
    if (!nextField) break;

    if (list.find((f) => f.id === nextField.value.id)) break; // prevent infinite looping in safe case
    list.push(nextField.value);
  }

  return list;
};
